<template>
  <div class="table-search">
    <div
      class="table-search-item"
      v-for="searchItem in searchList_all"
      :key="searchItem.prop"
      >
      <component :is="'search-'+searchItem.type" :propKey="searchItem.prop" :items="searchItem.items" v-model="searchForm[searchItem.prop]" @search="search" :attrs="searchItem.attrs" :isShopsSearch="searchItem.isShopsSearch" /> 
    </div>
     <div class="table-search-item">
      <el-date-picker
        v-model="operateTime"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        :picker-options="pickerOptions"
        :clearable="false"
      />
     </div>
    <div class="table-search-item"><el-button @click="search" style="height:100%" type="primary">查询</el-button></div>
    <div class="table-search-item"><el-button @click="clear" style="height:100%">清空</el-button></div>
    <slot></slot>
  </div>
</template>

<script>
import SearchSelect from "@/components/prod/center/components/SearchSelect.vue";
import SearchInput from "@/components/prod/center/components/SearchInput.vue";
import prod_center_dictionary from "@/components/prod/center/dictionary";
import {getDateStart, getDateEnd, pickerOptions} from "@/pages/supplier/prod/log/util";
import { mapGetters } from 'vuex';

export default {
  components: {
    SearchSelect,
    SearchInput,
  },
  data() {
    return {
      pickerOptions,
      searchForm: {
        shopId: '',
        outerId: '',
        startTime: '',
        endTime: '',
        subCode: ''
      },
      searchList_all: [
        {prop: "subCode", type: 'select', attrs:{placeholder: '途径'}, items: []},
        {prop: "status", type: 'select', attrs:{placeholder: '状态'}, items: prod_center_dictionary.UPDATE_PRODUCT_STATUS},
        {prop: "shopId", type: 'select', attrs:{placeholder: '店铺', multiple: false}, items: this.shops, isShopsSearch: true},
        {prop: "outerId", type: 'input', attrs: {placeholder: '款式编码'}},
      ],
      operateTime: [
        getDateStart(),
        getDateEnd(),
      ], 

    }
  },
  computed: {
    ...mapGetters(["routerPrefix", "getSubCode"]),
    query() {
      let _query = {}
      this.searchForm = {
        ...this.searchForm,
        startTime: this.operateTime[0],
        endTime: this.operateTime[1]
      }
       for (const key in this.searchForm) {
        if (this.searchForm[key] !== '') {
           _query[key] = this.searchForm[key]
          if(key == 'shopId' && _query[key]) {
            const val = this.shops.find(item => item.userId == _query[key])
            _query[key] = val?.id || ''
          }
        }
      }
      return _query
    },
    shops() {
      // const shops_all = this.$store.getters.shops_all.map(shop => ({label: shop.shortTitle || shop.title, value: shop.id, icon: shop.icon}))
      return this.$store.getters.shops_all
    },
  },
  watch: {
    shops: {
      handler(v) {
        const index = this.searchList_all.findIndex(item => item.prop === 'shopId')
        this.$set(this.searchList_all[index], 'items', v)
      },
      deep: true,
      immediate: true
    },
    getSubCode: {
      handler(newVal) {
        const index = this.searchList_all.findIndex(item => item.prop === 'subCode');
        if(index == -1) return;
        this.$set(this.searchList_all[index], 'items', [...newVal])
      },
      deep: true,
      immediate: true
    },
    operateTime(newVal) {
      if(newVal == null) {
        this.operateTime = [getDateStart(),getDateEnd()]
      }
    }
  },
  methods: {
    method_getSearchForm() {
      return this.query
    },
    search() {
      this.$emit('search', this.query)
    },
    clear() {
      this.operateTime = [
        getDateStart(),
        getDateEnd(),
      ], 
       this.searchForm =  {
        shopId: '',
        outerId: '',
        startTime: '',
        endTime: '',
        subCode: ''
      },
      this.search();
    },
  }
}
</script>

<style lang="scss" scoped>
.table-search {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;

  &-item {
    margin-right: 8px;
    margin-bottom: 8px;
  }

}
</style>
